import { StateSchema } from 'app/config/storeConfig/types';
import { UserType } from '../types';

export const getUserType = (state: StateSchema): Nullable<UserType> => state.chooseUserModal.userType;
